import NotFound from "../components/LegalAndUtilPages/NotFound/NotFound";

const NotFoundPage = () => {
  return <NotFound />;
};
export default NotFoundPage;
